import "./Affiliates.css";
import Affilli from "./images/Affiliates.png";

const Affliliates = () => {
    return ( 
        <>
            <h1 className="heading">Professional Afilliations</h1>
            <p className="para">As a leader in the construction sector, Amahle-Amashenge is committed to understanding and meeting the requirements of the regulatory frameworks that govern the industry. The company's leadership team are active members across a spectrum of relevant associations and regulatory bodies.</p>
            <img src={Affilli} alt="" />
        </>
     );
}
 
export default Affliliates;